import { render, staticRenderFns } from "./SummaryPageRedirect.vue?vue&type=template&id=601367f1&scoped=true&"
import script from "./SummaryPageRedirect.vue?vue&type=script&lang=js&"
export * from "./SummaryPageRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601367f1",
  null
  
)

export default component.exports